// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__ToGVr","vLegacy":"SelectSecondary_vLegacy__3QeS_","error":"SelectSecondary_error__27Euw","disabled":"SelectSecondary_disabled__3-1TT"};